import React from 'react';

import {SimpleSelect} from '../../select';
import {MODE_OPTIONS} from './constants';

interface SelectModeProps {
  selected: any;
  onChange: (value: any) => void;
  disabled?: boolean;
}

export const SelectMode = ({
  selected,
  onChange,
  disabled = false,
}: SelectModeProps) => {

  return (
    <SimpleSelect
      disabled={disabled}
      selected={selected}
      options={MODE_OPTIONS}
      onChange={onChange}
      buttonProps={{
        minimal: true,
        small: true,
        outlined: false,
      }}
      popoverProps={{
        usePortal: true
      }}
    />
  )
};

export default SelectMode;
